import { render, staticRenderFns } from "./subprogramListAdvisor.vue?vue&type=template&id=5d5722e7"
import script from "./subprogramListAdvisor.vue?vue&type=script&lang=js"
export * from "./subprogramListAdvisor.vue?vue&type=script&lang=js"
import style0 from "./subprogramListAdvisor.vue?vue&type=style&index=0&id=5d5722e7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports